import { Component, OnInit, ErrorHandler } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import { Search } from '../../shared/user.model';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'app-investigation-form',
  templateUrl: './investigation-form.component.html',
  styleUrls: ['./investigation-form.component.css']
})
export class InvestigationFormComponent implements OnInit {

  // constructor() { }
  title = " Investigation Documents";
  itemsPerPage: number=5;
  currentPage: number=1;
  InvestigationDetailsList : any = {};
  data : any = {};
  totalItems : number;
  s: Search;
  isSearch:boolean;
  Fir_id : number;
  InvDoc_Id : number;
  FirDetails : any = [];
  Departmentlist: any = {}
  DepartmentDoclist: any = {}
  Investigationdetails : any = {};  
  formInvalid: boolean;
  fileToUpload: File;
  p : any = {};
  numericpattern = "^[0-9]*$";
  alphabetpattern = "^[a-zA-Z ]*$";
  alphanumpattern = "^[a-zA-Z0-9 ]*$";
  emailpattern = "^[a-zA-Z0-9._%-+]+@[a-z0-9.-]+\.[a-z]{2,3}$"; 
  io : any = {};
  i : any = {};
  mode : string;
  dd: any = {};
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler) {
    this.s = new Search();
    this.isSearch = false;
   }

  ngOnInit() {
    this. GetAllData();
   

    this.route.params.subscribe(params => {
      this.mode = params['mode'];
      this.Fir_id = params['Fir_id'];  
      this.InvDoc_Id = params['InvDoc_Id'];     
     // this.GetFirDetails(this.Fir_id);  
      // this.GetProceedingDetails(this.itemsPerPage, 1); 
      if(this.mode!='view') 
      {
        debugger;
      this.GetInvestigationDetails(this.itemsPerPage,1,this.Fir_id); 
      this.GetFirDetails(this.Fir_id);  
      }
      if(this.mode=='view'){
        debugger;
      if(this.InvDoc_Id > 0){
        this.GetInvestigationById(this.InvDoc_Id);
    }
  }
    });


  }
 
  GetAllData() {
    debugger;
    //Get All department 
    this.data = this.userService.GetAllDepartment();
    this.data.subscribe(
      (response: any) => {
        this.Departmentlist = response.Result;
      })

// //get all department doc
// this.data = this.userService.GetAllDepartmentDoc();
//     this.data.subscribe(
//       (response: any) => {
//         this.DepartmentDoclist = response.Result;
//       })

   }

    GetDepDoc(dep_Id){    
      // alert("hi") 
      this.data = this.userService.GetDeptDoc(dep_Id);
      this.data.subscribe(
        (response:any) =>{
          this.DepartmentDoclist= response.Result;
          console.log(response)
          // console.log(this.DepartmentDoclist)
        })
    }
  GetFirDetails(Fir_id){
       document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetFirInvestigationetails(Fir_id);
    this.data.subscribe(
      (response: any) => {       
        this.FirDetails = response
        console.log('this.FirDetails');
        console.log(this.FirDetails);
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 401|| error.status == 500) {
          this.errorHandler.handleError(error);
        }
        else if (error.status == 400) {
          swal('Warning!', error.error.Message, 'warning');
        }
      });
  }

  
  SaveInvestigation(Investigation: NgForm){  
    debugger; 
    
    if(Investigation.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }     
  
    else{                    
      Investigation.value.FirId = this.Fir_id ;
      Investigation.value.InvDoc_File_Name = this.getFeasibilityInvestigsationBriefFUrl();

      console.log('Save');
      console.log(Investigation.value);
         
            this.data = this.userService.PostInvestigation(Investigation.value);    
            this.data.subscribe(
            (response) => {
              Investigation.reset();
              Investigation.resetForm();
              Investigation.form.markAsPristine();
              Investigation.form.markAsUntouched();        
              swal('Success!', 'Investigation Added Successfully .', 'success');
              //this.router.navigate(['/home/investigation-doc/fir-prceeding']) ; 
              this.GetInvestigationDetails(this.itemsPerPage,1,this.Fir_id);    
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.handleError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });       
           
    } 
  }


  getId(Id){
    //alert(Id)
    this.InvDoc_Id  = Id;
    let i: any = document.getElementById('InvDoc_File_Name');
    i.value = "";
  }


  //UpdateFile
  UpdateFile(Investigation: NgForm){
    //lert('Update')
    //var Investigation 
    Investigation.value.InvDoc_Id = this.InvDoc_Id ;
    Investigation.value.InvDoc_File_Name = this.getFeasibilityInvestigsationBriefFUrl();

    console.log('Form');
    console.log(Investigation.value)

    this.data = this.userService.UpdateFile(Investigation.value,this.InvDoc_Id);    
    this.data.subscribe(
    (response) => {
      Investigation.reset();
      Investigation.resetForm();
      Investigation.form.markAsPristine();
      Investigation.form.markAsUntouched(); 
      swal('Success!', 'File Added Added Successfully .', 'success');
    }
    )

  }

//upload
  imageUpload1(file: FileList) {
    debugger;
        let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
    
        let s: any = file.item(0).size / 1024;
        let size: any = parseFloat(s).toFixed(2);
        let uploadedFilename = file.item(0).name;
        if (uploadedFilename.match(regex) && (size <= 5048)) {
          this.fileToUpload = file.item(0);
          var reader = new FileReader();
          reader.onload = (event: any) => {
            //  this.IS_UploadPath = event.target.result;
          }
          reader.readAsDataURL(this.fileToUpload);
          const data = new FormData();
          data.append("UploadedImage", file.item(0));
          let x = this.userService.uploadImage6(data);
          x.subscribe(
            (response) => {
              
            }, (error) => {
              let i: any = document.getElementById('InvDoc_File_Name');
              i.value = "";
              if (error.status == 400) {
                //this.FeasibilityPDFUrl = "assets/images/image-default.png";
                swal('Warning!', error.error.Message, 'warning');
              }
            });
        }
        else {
          let i: any = document.getElementById('InvDoc_File_Name');
          i.value = "";
          if (!uploadedFilename.match(regex))
            swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
          else if (size > 2048)
            swal('Warning!', "Please upload image file less than 2mb", 'warning');
        }
      }
    
    
    
      getFeasibilityInvestigsationBriefFUrl() {
        let imagename = null;      
        try {
          imagename = document.getElementById('InvDoc_File_Name');         
          console.log(imagename.files[0].name);
          return imagename.files[0].name;
        }
        catch (e) {
          return null;
        }
      }
  
      //getting Proceeding
      GetInvestigationDetails(itemsPerPage:any,pageNo:any,Fir_id){
        debugger;
        //alert('Inside');
        this.isSearch = false;
          document.getElementById('loader-spinner').style.display = "block";
          this.data = this.userService.GetAllInvestigationDetails(itemsPerPage,pageNo,this.Fir_id);
          this.data.subscribe(
            (response: any) => {
              this.InvestigationDetailsList = response.InvestigationDocumentModel;
                this.totalItems = response.TotalItemsCount;
                this.itemsPerPage = itemsPerPage;
                this.currentPage = pageNo;  
              document.getElementById('loader-spinner').style.display = "none";
            },(error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.handleError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });
        } 
        //getbyid VIEW


        GetInvestigationById(InvDoc_Id){
          this.mode = 'view'
          document.getElementById('loader-spinner').style.display = "block";
              this.data = this.userService.GetInvestigationById(InvDoc_Id);
              this.data.subscribe(
                (response: any) => {
                  this.io = response;        
                                
                  document.getElementById('loader-spinner').style.display = "none";
                },(error) => {
                  document.getElementById('loader-spinner').style.display = "none";
                  if (error.status == 401|| error.status == 500) {
                    this.errorHandler.handleError(error);
                  }
                  else if (error.status == 400) {
                    swal('Warning!', error.error.Message, 'warning');
                  }
                });
        }
        
        pageChanged(pageNumber: number) {
         // if (this.isSearch)
            //this.onSearch(this.s,this.itemsPerPage, pageNumber);
          //else
            this.GetInvestigationDetails(this.itemsPerPage, pageNumber,this.Fir_id);
        }
      
        itemsPerPageChanged(itemsPerPage: number, pageNo: number) {
         // if (this.isSearch)
           // this.onSearch(this.s,this.itemsPerPage, pageNo);
         // else
            this.GetInvestigationDetails(this.itemsPerPage, pageNo,this.Fir_id);
        }
    
    
      //Search item
    
    
      onSearch(Fir_id,s,itemsPerPage: number, pageNo: number) {  
        debugger; 
        this.isSearch = true;
        let searchText = this.s.SearchText;
        let searchCriteria = this.s.SearchCriteria;
        if (searchText == "" || searchText == null || searchCriteria == "" || searchCriteria == null)
          swal("Warning!", "Please enter the search criteria and search text.", "warning");
        else {
          document.getElementById('loader-spinner').style.display = "block";
          this.userService.GetInvestigationOnSearch(this.Fir_id,searchCriteria, searchText, itemsPerPage,pageNo)
            .subscribe(
              (data: any) => {
                if(data.InvestigationDocumentModel.length!=0){              
                this.InvestigationDetailsList = data.InvestigationDocumentModel;
                this.totalItems = data.TotalItemsCount;
                this.currentPage = pageNo;
                document.getElementById('loader-spinner').style.display = "none";
              }
              else
              {
              document.getElementById('loader-spinner').style.display = "none";         
              }
              }, (error) => {
                document.getElementById('loader-spinner').style.display = "none";
                if (error.status == 401|| error.status == 500) {
                  this.errorHandler.handleError(error);
                }
                else if (error.status == 400) {
                  swal('Warning!', error.error.Message, 'warning');
                }
              });
        }
      }
      // Saveimage(){
      //  this.imageUpload1()


      // }

      delete(InvDoc_Id){
        swal({
             title: 'Are you sure?', text: "You want to delete!", type: 'warning', showCancelButton: true, confirmButtonColor: '#3085d6', cancelButtonColor: '#d33', confirmButtonText: 'Yes, delete it!'
          }).then((result) => {
            if (result.value) {
            this.data = this.userService.DeleteInvestigationById(InvDoc_Id);
            this.data.subscribe(
             (response: any) => {
                 this. GetInvestigationDetails(this.itemsPerPage, 1,this.Fir_id)          
             },(error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401|| error.status == 500) {
                this.errorHandler.handleError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            }       
          ); 
        } 
        })
        }
    
    
    }
    



// WEBPACK FOOTER //
// ./src/app/investigationdocs-for-investigation/investigation-form/investigation-form.component.ts